import React from 'react'
import { StyledSpinner } from './styled'
import { SpinnerProps } from './Spinner.types'
import colors from '../../constants/colors'
import { colorIndex } from '../../constants/colors/colors.types'

const Spinner: React.FC<SpinnerProps> = ({
  size = '24px',
  color = 'blue50',
  emptyColor,
  ...props
}) => {
  return (
    <StyledSpinner
      color={colors[color as colorIndex] || color}
      size={size}
      emptyColor={colors[emptyColor]}
      borderRadius='50%'
      width={size}
      height={size}
      {...props}
    />
  )
}

export default Spinner
